<script>
import store from '../store';
import autoShowImg from '../../assets/autoShow-img.png';
import {getPlatform} from '../../../../common/util';
import {reduce} from 'lodash';
export default {
    data() {
        return {
            title: store.autoshow.title
        }
     },
    computed: {
        image() {
            return autoShowImg;
        }
    },
    mounted() {
        // 添加咨询文章曝光点击
		this.$clickMonitor.update(reduce(document.querySelectorAll('.autoShow'), (arr, el) => {
			const callback = function (params) {
				const buttonId = `brandVrhall-${params.monitor.status}`;
				return {
					buttonId,
					...store.getClickMonitorParams()
				};
			};
			arr.push({el, event: 'expose', callback});
			arr.push({el, event: 'click', callback});
			return arr;
		}, []));
    },
    methods: {
        jumpShow() {
            // app
            if( getPlatform() === 3 ) {
                window.open("autohome://insidebrowserwk?_ahrotate=2&navigationbarstyle=2&url=https%3a%2f%2fvr.autohome.com.cn%2fas3d%2f26000%3fsceneName%3dscene_3636%26pvareaid%3d6837856&navigationbarstyle=2");
            } else {
                window.open('https://vr.autohome.com.cn/as3d/26000?sceneName=scene_3636&pvareaid=6837856')
            }
        }
    }
}
</script>

<template>
<div class="wrap">
    <div class="title">
        {{title}}
        <i class="title-icon"></i>
    </div>
    <img :src="image" alt="" @click="jumpShow" class="autoShow">
</div>
</template>

<style lang="stylus" scoped>
.wrap
    width 18.375rem
    margin 0 auto 1rem auto
    font-size 0
	text-align center
	overflow hidden
.title
	margin 0.96rem 0 0.8125rem
.wrap img
    width 100%
</style>